module.exports = __webpack_public_path__ + "static/media/Braid.42ae450f.jpeg";